module.exports = __webpack_public_path__ + "static/media/captivating-4.cdbcd0a5.png";